import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Text } from '~/shared/ui'
import { useReminderSelectors } from '../model'
import { PdfTabReminderIllustration } from './pdf-tab-reminder-illustration'

// Non-dismissable reminder popup. Rendered via Radix Dialog in non-modal mode
// so it does not trap focus, render an overlay, or hijack keyboard/pointer
// events. The only way to close it is the 5-second timer in the store.
export function PdfTabReminderHost() {
  const { isOpen, message } = useReminderSelectors()

  if (!isOpen || message === null) {
    return null
  }

  return (
    <DialogPrimitive.Root
      open
      modal={false}
    >
      <DialogPrimitive.Portal>
        <div className="pointer-events-none fixed inset-0 z-60 flex items-center justify-center">
          <DialogPrimitive.Content
            className="pointer-events-auto flex w-[227px] flex-col items-center gap-2 rounded-lg bg-white p-3 shadow-[0_0.25px_3px_0_rgba(0,0,0,0.04),0_2.75px_9px_0_rgba(0,0,0,0.19)]"
            aria-describedby={undefined}
            // Block every built-in dismiss path — only the 5s timer may close.
            onOpenAutoFocus={(event) => event.preventDefault()}
            onCloseAutoFocus={(event) => event.preventDefault()}
            onEscapeKeyDown={(event) => event.preventDefault()}
            onPointerDownOutside={(event) => event.preventDefault()}
            onInteractOutside={(event) => event.preventDefault()}
          >
            <PdfTabReminderIllustration />
            <DialogPrimitive.Title asChild>
              <Text
                className="text-center whitespace-pre-line"
                appearance="SUBTITLE2"
              >
                {message}
              </Text>
            </DialogPrimitive.Title>
          </DialogPrimitive.Content>
        </div>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
